<div
  class="x--alert-_2291-13769"
  [class.x--alert--error]="isError"
>
  <div class="icon-container_I2291-13769-6642-19470">
    <img
      class="checkcircleoutlined_I2291-13769-6642-19471"
      [src]="isError ? 'assets/images/Error_icon.svg' : 'assets/images/Successful_icon.svg'"
      [alt]="isError ? 'Error icon' : 'Success icon'"
      aria-hidden="true"
    />
  </div>

  <div class="text_I2291-13769-6642-19472">
    @if (titleText) {
      <span class="text--title-_I2291-13769-6642-19473">{{ titleText }}</span>
    }
    <span class="text-description_I2291-13769-6642-19474">{{ descriptionText }}</span>
  </div>
</div>
